/**
 * 站点语言配置（唯一开关）
 * ------------------------------------------------------------------
 * 改 SITE_LOCALE 一行即可切换整站语言：
 *   'en'    美式英语（默认）
 *   'zh-CN' 简体中文
 *   'zh-TW' 繁体中文
 * 站点不提供语言切换入口，也不随浏览器语言自动切换。
 * （隐藏预览页 /Language 可临时覆盖，写入 localStorage.site_locale，仅供内部预览）
 */

export const SITE_LOCALE = 'en';

export const SUPPORTED_LOCALES = ['en', 'zh-CN', 'zh-TW'];

// 前端语言 -> Vant 组件语言包
export const VANT_LOCALE = {
  'en': 'en-US',
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW'
};

// 前端语言 -> 后端语言集（对应 application/api/lang/{name}.php）
export const SERVER_LANG = {
  'en': 'en',
  'zh-CN': 'zh-cn',
  'zh-TW': 'zh-tw'
};

const STORAGE_KEY = 'site_locale';

export function getLocale() {
  let locale = SITE_LOCALE;
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && SUPPORTED_LOCALES.indexOf(saved) !== -1) {
      locale = saved;
    }
  } catch (e) {
    // localStorage 不可用时忽略
  }
  return locale;
}

export function setLocale(locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch (e) {
    // ignore
  }
}

export function clearLocale() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // ignore
  }
}

export function getVantLocale() {
  return VANT_LOCALE[getLocale()] || 'en-US';
}

export function getServerLang() {
  return SERVER_LANG[getLocale()] || 'en';
}

export function isEnglish() {
  return getLocale() === 'en';
}

export function isTraditional() {
  return getLocale() === 'zh-TW';
}

/**
 * 兼容只有「中文 / 英文」两套的历史数据映射（玩法名、滚动公告等）
 * 简体与繁体统一走中文分支
 */
export function getLangKind() {
  return isEnglish() ? 'en' : 'zh';
}

/**
 * 接口数据里形如 "简体|English|日本語|한국어" 的多语言字段
 * 简体/繁体取第 0 段，英文取第 1 段
 */
export function getPipeLangIndex() {
  return isEnglish() ? 1 : 0;
}
